import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full pt-x2 md:pt-x3" }

import { B2CContentPageContent } from '@/types/B2CcontentServerContract';
import HeroBannerHandler from '@/shared/content/blocks/hero-banner/HeroBannerHandler.vue';
import BlockList from '@/shared/content/blocks/helpers/BlockList.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'B2CContentPage',
  props: {
    content: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.content.hero)
      ? (_openBlock(), _createBlock(HeroBannerHandler, {
          key: 0,
          content: __props.content.hero
        }, null, 8, ["content"]))
      : _createCommentVNode("", true),
    _createVNode(BlockList, {
      blocks: __props.content.tiles
    }, null, 8, ["blocks"])
  ]))
}
}

})